import { erpApiFile, erpApiFileAWT } from '@/shared/axios';
import { IDataFile } from '@/shared/constants/interface';
import {
  urlBucket,
  urlDrive,
  urlDriveSingle,
} from '@/shared/constants/networking.constants';
import { AlertSeverityEnum, ArchivoDriveById, SendRquestParams } from '@/shared/interfaces';
import { handleAxiosError } from '@/shared/utils';
import { useUiStore } from '@/store/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type CreateFileDocumentProps = {
  archivo: File;
  nombre: string;
  carpeta_padre?: number;
  user?: number;
};

const { post, get, put, remove } = erpApiFile();
const { put: putFileNew, remove: removeFileNew } = erpApiFileAWT();

export const useCreateFileAwt = () => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  // const setAlert = useUiStore(s => s.setAlert);

  return useMutation({
    mutationFn: async (params: SendRquestParams) => {
      return createFileAwt(params)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fileDocument'] });
    },
    onError: e => {
      // setAlert(
      //   true,
      //   'Ocurrió un problema al cargar el archivo, por favor, intente nuevamente.',
      //   AlertSeverityEnum.error
      // );
      console.log(e);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const createFileAwt = async (params: SendRquestParams) => {
  const res = await putFileNew(params);
  return res;
};

//CREAR ARCHIVO
export const useCreateFileDocument = () => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: createFileDocument,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fileDocument'] });
    },
    onError: e => {
      console.log('Error de imagen');

      const axiosError = e as AxiosError;

      if (axiosError.status === 401) {
        setAlert(
          true,
          'Cabecera token inválida. Las credenciales no fueron suministradas',
          AlertSeverityEnum.error
        );
      }
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const createFileDocument = async (data: CreateFileDocumentProps) => {
  const res = await post<IDataFile>(urlDrive, data, true);
  return res;
};

export const getDocumentById = async (id: number | string) => {
  const res = await get<IDataFile>(`${urlDrive}${id}/`, true);
  return res;
};

export const getDocumentsByIdsArray = async (ids: string[]) => {
  const res = await post<ArchivoDriveById[]>(
    `${urlDriveSingle}/archivos-get/`,
    { pks: ids },
    true,
    true,
    'application/json'
  );
  return res;
};

//ACTUALIZAR ARCHIVO

export const useUpdateDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      data,
    }: {
      id: string;
      data: CreateFileDocumentProps;
    }) => {
      return updateDocument(id, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fileDocument'] });
    },
    onError: error => {
      handleAxiosError(error);
    },
  });
};

export const updateDocument = async (
  id: number | string,
  data: CreateFileDocumentProps
) => {
  const res = await put<IDataFile>(`${urlBucket}${id}/`, data, true);
  return res;
};


/**
 * Eliminar documento | image
 * 
*/

export const deleteDocument = async (
  id: number | string,
) => {
  const res = await remove<IDataFile>(`${urlDrive}${id}/`, true);
  return res;
};


export const deleteFileNewAwt = async (params: SendRquestParams) => {

  const res = await removeFileNew(params);
  return res;
};
